export class QaVisit {
  id: string = null;
  date: string = null;
  timein: string = null;
  timeout: string = null;
  trainno: string = null;

  powertrainId: string = null;
  powertrain: any = null;

  engine1: string = null;
  engine2: string = null;

  generator1: string = null;
  generator2: string = null;

  engine1speed: string = null;
  engine1volt: string = null;
  engine1temp: string = null;
  engine1amp: string = null;
  engine1oilpressure: string = null;
  engine1hoursread: number = null;

  engine2speed: string = null;
  engine2volt: string = null;
  engine2temp: string = null;
  engine2amp: string = null;
  engine2oilpressure: string = null;
  engine2hoursread: number = null;

  notes1: string = null;
  notes2: string = null;

  troubleshooting: any = null;
  troubleshootingbox: any = null;

  supervisor: string = null;
  engineer: string = null;

  reviewed: boolean = false;
  accountId: string = null;
  reviewerId: string = null;

  created: Date = null;
  updated: Date = null;

  status: number = 0;

  reset() {
    this.id = null;
    this.date = null;
    this.timein = null;
    this.timeout = null;
    this.trainno = null;

    this.powertrainId = null;
    this.powertrain = null;

    this.engine1 = null;
    this.engine2 = null;

    this.generator1 = null;
    this.generator2 = null;

    this.engine1speed = null;
    this.engine1volt = null;
    this.engine1amp = null;
    this.engine1temp = null;
    this.engine1oilpressure = null;
    this.engine1hoursread = null;

    this.engine2speed = null;
    this.engine2volt = null;
    this.engine2amp = null;
    this.engine2temp = null;
    this.engine2oilpressure = null;
    this.engine2hoursread = null;

    this.troubleshootingbox = null;
    this.troubleshooting = null;

    this.notes1 = null;
    this.notes2 = null;

    this.supervisor = null;
    this.engineer = null;
    this.reviewed = false;
    this.accountId = null;
    this.reviewerId = null;

    this.created = null;
    this.updated = null;
    this.status = 0;
  }
}
